import React, { useState } from "react";

const ScheduleModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const API_URL = process.env.REACT_APP_API_URL || "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/schedule/createSchedule`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!res.ok) {
        throw new Error("Failed to submit form");
      }

      const data = await res.json();
      console.log("Form Submitted:", data);

      setShowSuccessModal(true);
      setFormData({ name: "", email: "", mobile: "", message: "" });

      setTimeout(() => {
        setShowSuccessModal(false);
        onClose();
      }, 3000);
    } catch (error) {
      console.error("Error:", error);
      alert("Somehing went wrong! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 w-[90%] max-w-md shadow-lg relative">
        {showSuccessModal ? (
          <div className="text-center py-8">
            <h2 className="text-xl font-semibold text-[#4BB543] mb-2">
              Thank you!
            </h2>
            <p className="text-gray-700">Oethical team will contact you.</p>
          </div>
        ) : (
          <>
            <h2 className="text-xl font-semibold mb-4">Book a Schedule</h2>

            <form className="space-y-4" onSubmit={handleSubmit}>
              <div>
                <label className="block text-sm font-medium mb-1">
                  Name
                  <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Email
                  <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Mobile
                  <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Enter your mobile number"
                  required
                  value={formData.mobile}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Message
                </label>
                <textarea
                  name="message"
                  placeholder="Write your message"
                  rows="3"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                />
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  className="text-white px-4 py-2 rounded bg-[#9bd66c] hover:bg-[#86bf59]"
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </>
        )}

        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-xl text-gray-500 hover:text-black"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default ScheduleModal;
